// Minimal mockData to satisfy imports used across pages
export const exponentRules = [
  { name: 'Power Rule', formula: "x^n -> n x^{n-1}" }
];
export const radicalRules = [
  { name: 'Radical Simplification', formula: 'n√(a^m) = a^{m/n}' }
];
export const exponentFAQs = [
  { q: 'How do exponents work?', a: 'Multiply powers when bases equal.' }
];
export const scientificNotationFAQs = [
  { q: 'How to convert to scientific notation?', a: 'Move decimal to have one non-zero digit before it.' }
];
export default { exponentRules, radicalRules, exponentFAQs, scientificNotationFAQs };